export default __webpack_public_path__ + "static/media/lookup.6159f71f.svg";